__turbopack_context__.v({
  "copyActionElement": "UHAppDownloadModal-module__vW0_FW__copyActionElement",
  "copyLink": "UHAppDownloadModal-module__vW0_FW__copyLink",
  "desktopOnly": "UHAppDownloadModal-module__vW0_FW__desktopOnly",
  "flex": "UHAppDownloadModal-module__vW0_FW__flex",
  "linkContent": "UHAppDownloadModal-module__vW0_FW__linkContent",
  "qr": "UHAppDownloadModal-module__vW0_FW__qr",
  "root": "UHAppDownloadModal-module__vW0_FW__root",
  "stacked": "UHAppDownloadModal-module__vW0_FW__stacked",
});
